import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MDTypography from "ui/MDTypography";
import { DetailRow } from "layouts/common/detail-page";
import { DetailPageLayout } from "examples/LayoutContainers/DetailPageLayout";
import { Grid, Card, Box, Chip, Avatar, Typography } from "@mui/material";
import meetingServices from "services/meeting-services";
import attendanceServices from "services/attendance-services";
import karkunService from "services/karkun-service";



const AttendanceDetail = () => {
  const { id } = useParams();
  const [attendance, setAttendance] = useState([]);
  const [loading, setLoading] = useState(true);
  const [marked, setMarked] = useState([]);



  useEffect(() => {
    getMeetings();
  }, []);

  const getMeetings = async () => {
    const meetingData = await meetingServices.getattendancemeeting();
    console.log("meetingData", meetingData);
    if (meetingData.success && meetingData.meetings) {
      const formattedMeetings = meetingData.meetings.map(meeting => ({
        ...meeting,
        date: meeting.date ? new Date(meeting.date).toLocaleDateString("en-CA") : ""
      }));
      setAttendance(formattedMeetings);
    }
  };


  useEffect(() => {
    const loadData = async () => {
      try {

        // 1) Attendance API
        const res = await attendanceServices.getall(id);
        const presentOnly = res.attendees?.filter(
          (a) => a.status?.toLowerCase() === "present"
        );

        // 2) Karkuns API
        const karkunRes = await karkunService.getAll();
        const karkunList = karkunRes.karkuns || [];

        // 3) Mapping
        const mapped = presentOnly.map((item) => {
          const k = karkunList.find(
            (x) => x.karkunid?.toLowerCase() === item.karkunId?.toLowerCase()
          );
          return {
            name: k?.name || "Unknown",
            karkunid: k?.karkunid,
            status: "Present",
          };
        });

        setMarked(mapped);

        // 4) ---> SUMMARY CALCULATION <---
        setAttendance((prev) => ({
          ...prev,
          summary: {
            totalKarkuns: karkunList.length,
            presentKarkuns: mapped.length,
          },
        }));

      } catch (e) {
        console.error(e);
      }

      setLoading(false);
    };

    loadData();
  }, [id]);


  const renderAttendanceDetails = () => {
    if (marked.length === 0) {
      return (
        <MDTypography variant="body2" color="error">
          No Attendance Marked
        </MDTypography>
      );
    }

    return (
      <Grid container spacing={3} padding={1}>

        {/* ===== Summary Cards ===== */}
        <Grid item xs={12} md={6}>
          <Card
            sx={{
              p: 3,
              borderRadius: 4,
              boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
              background: "linear-gradient(195deg, #3ba484, #1c754df2)",
              color: "white !important",
            }}
          >
            <Typography variant="h6" sx={{ opacity: 0.9, color: "white !important" }}>
              Total Karkuns
            </Typography>

            <Typography variant="h2" sx={{ fontWeight: 800, mt: 1, color: "white !important" }}>
              {attendance.summary?.totalKarkuns ?? "0"}
            </Typography>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card
            sx={{
              p: 3,
              borderRadius: 4,
              boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
              background: "linear-gradient(195deg, #3ba484, #1c754df2)",
              color: "white !important",
            }}
          >
            <Typography variant="h6" sx={{ opacity: 0.9, color: "white !important" }}>
              Present Today
            </Typography>

            <Typography variant="h2" sx={{ fontWeight: 800, mt: 1, color: "white !important" }}>
              {attendance.summary?.presentKarkuns ?? "0"}
            </Typography>
          </Card>
        </Grid>

        {/* ===== Attendance List ===== */}
        {marked.map((item, index) => (
          <Grid item xs={12} md={6} key={index}>
            <Card
              sx={{
                p: 2.2,
                borderRadius: 3,
                boxShadow: "0 2px 10px rgba(0,0,0,0.07)",
              }}
            >
              <Box display="flex" alignItems="center" mb={2}>
                <Avatar sx={{ bgcolor: "#4caf50", mr: 1.5 }}>
                  {item.name?.charAt(0)}
                </Avatar>

                <MDTypography variant="h6" fontWeight="medium">
                  {item.name}
                </MDTypography>

                <Chip
                  label="Present"
                  color="success"
                  sx={{ ml: "auto", fontWeight: "bold" }}
                />
              </Box>

              <DetailRow label="Karkun ID" value={item.karkunid} />
            </Card>
          </Grid>
        ))}

      </Grid>

    );
  };

  return (
    <DetailPageLayout
      title="Attendance Details"
      renderContent={renderAttendanceDetails}
      backButtonRoute="/meetings"
      loading={loading}
    />
  );
};

export default AttendanceDetail;
